import React, { useState, useContext } from "react";
import { Navbar, Nav, Container, Button, Modal } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../shared/context/auth-context";
import styles from "./TopNavbar.module.css";

const TopNavbar = () => {
	const { isSuperAdmin, orgRole } = useContext(AuthContext);
	const [showHelpModal, setShowHelpModal] = useState(false);
	const navigate = useNavigate();

	const menuItems = [
		{ to: "/", icon: "columns", label: "Dashboard" },
		{
			to: "/videos",
			icon: "photo-video",
			label: "Videos",
			tourTarget: "studio",
		},
		{
			to: "/scripts",
			icon: "file",
			label: "Scripts",
			tourTarget: "script-writer",
		},
		{
			to: "/audios",
			icon: "music",
			label: "Audios",
		},
		{
			to: "/folders",
			icon: "folder",
			label: "Folders",
		},
		{ to: "/tickets", icon: "ticket", label: "Tickets" },
		{
			to: "/interactive",
			icon: "comment-dots",
			label: "Interactive",
		},
		{ to: "/team", icon: "users", label: "Team", tourTarget: "team" },
		{ to: "/subscription", icon: "credit-card", label: "Subscription"},
		{ to: "/settings", icon: "cog", label: "Settings", tourTarget: "settings" },
	];

	if (isSuperAdmin) {
		menuItems.push(
			{
				to: "/admin",
				icon: "lock",
				label: "Admin Settings",
			},
			{
				to: "/add-avatar",
				icon: "user-plus",
				label: "Add Avatar",
			},
			{
				to: "/user-list",
				icon: "users",
				label: "User List",
			}
		);
	} else if (orgRole === "orgAdmin") {
		menuItems.push({
			to: "/organizations",
			icon: "lock",
			label: "Org Settings",
		});
	}

	const handleNewVideo = () => {
		navigate("/videos/new");
	};

	return (
		<Navbar
			bg="white"
			variant="light"
			expand="lg"
			fixed="top"
			className={`py-2 border-bottom ${styles.navbar}`}
			data-tour-target="sidebar"
		>
			<Container fluid data-testid="container-fluid">
				<Navbar.Brand as={NavLink} to="/" className={styles.brand}>
					<img
						src="/logo.png"
						alt="Ratava"
						height="30"
						className={`d-inline-block align-top ${styles.brandImage}`}
					/>
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="basic-navbar-nav" />
				<Navbar.Collapse id="basic-navbar-nav" data-testid="basic-navbar-nav">
					<Nav className="me-auto">
						{menuItems.map((item, index) => (
							<Nav.Link
								key={index}
								as={NavLink}
								to={item.to}
								data-tour-target={item.tourTarget}
								className={({ isActive }) =>
									isActive ? styles.navLinkActive : styles.navLink
								}
								style={({ isActive }) => ({
									color: isActive ? "#007bff" : "#6c757d",
									visibility: "visible",
									opacity: 1,
								})}
							>
								<i className={`fa fa-${item.icon} ${styles.navIcon}`}></i>
								{item.label}
							</Nav.Link>
						))}
					</Nav>
					<div
						className={styles.actionButtons}
						style={{ visibility: "visible", opacity: 1 }}
					>
						<Button
							variant="primary"
							className={styles.newVideoButton}
							onClick={handleNewVideo}
							style={{ visibility: "visible", opacity: 1 }}
						>
							New Video
						</Button>
						<Button
							variant="dark"
							className={styles.helpButton}
							onClick={() => setShowHelpModal(true)}
							style={{ visibility: "visible", opacity: 1 }}
						>
							?
						</Button>
						{/*<Button
							variant="primary"
							className={styles.newVideoButton}
							onClick={() => {
								window.location.href = "https://billing.stripe.com/p/login/test_aFadR888Q8Rk2UH8tsgUM00";//?prefilled_email=" + encodeURIComponent();
							}}
							style={{ visibility: "visible", opacity: 1 }}
						>
							Stripe Portal
						</Button>*/}
					</div>
				</Navbar.Collapse>
			</Container>
			<HelpModal show={showHelpModal} onHide={() => setShowHelpModal(false)} />
		</Navbar>
	);
};

const HelpModal = ({ show, onHide }) => {
	return (
		<Modal show={show} onHide={onHide} centered size="lg">
			<Modal.Header closeButton className={styles.modalHeader}>
				<Modal.Title className={styles.modalTitle}>Tutorial</Modal.Title>
			</Modal.Header>
			<Modal.Body className={styles.modalBody}>
				<div style={{ textAlign: "center" }}>
					<div className={styles.videoContainer}>
						<iframe
							src="https://drive.google.com/file/d/1LlNLlkbfiucnlaLYLl6UrwVpLCwH3RuS/preview"
							allow="encrypted-media"
							allowFullScreen
							title="Tutorial Video"
							className={styles.videoFrame}
						></iframe>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default TopNavbar;
